import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IngSelect } from '../../inputs';

@Component({
  selector: 'ing-ng2-select',
  templateUrl: './ng2-select.component.html',
  styleUrls: ['./ng2-select.component.scss']
})
export class Ng2SelectComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngSelect;

  selectedValue;
  private value: any = {};

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-ng2-select';

    if (this.input.multiple) {
      this.selectedValue = this.input.options.filter(op => {
        return !![].find.call(this.input.value, i => i === op.id);
      });
    } else {
      this.selectedValue = this.input.options.filter(op => op.id === this.input.value);
    }

    if (!!this.form) {
      this.form.controls[this.input.key].valueChanges.subscribe(data => {
        if (typeof(data) === 'string') {
          this.selectedValue = this.input.options.filter(op => op.id === data);
        }
      });
    }
  }

  selected($event) {
    if (this.input.multiple) {
      this.form.controls[this.input.key].setValue(this.value.map(v => v.id));
    } else {
      this.form.controls[this.input.key].setValue($event.id);
    }
  }

  refreshValue(value: any): void {
    return this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/ng2-select/ng2-select.component.ts